module.exports = __webpack_public_path__ + "img/workShopReview_banner_m.bdddb310.png";